import React, { useContext } from 'react';

import { LocationMotivation } from 'registration/components/new_pages/OnboardingLocationMotivation/constants';
import { LocationMotivationButtonSelect } from 'registration/components/new_pages/OnboardingLocationMotivation/LocationMotivationButtonSelect';
import {
  Onboarding,
  OnboardingContext,
  OnboardingSubtitle,
  OnboardingTitle,
} from 'registration/containers/Onboarding';

import {
  BusinessDealIcon,
  MoneyBagsIcon,
  StairsAscendIcon,
} from 'shared/components/ihcl/icon';
import { Center } from 'shared/components/ihcl/positioning';

const motivationOptions = [
  {
    label: (
      <>
        <StairsAscendIcon /> Career advancement
      </>
    ),
    value: LocationMotivation.CareerAdvancement,
  },
  {
    label: (
      <>
        <BusinessDealIcon /> Possibility of getting hired
      </>
    ),
    value: LocationMotivation.PlacementPotential,
  },
  {
    label: (
      <>
        <MoneyBagsIcon /> Compensation
      </>
    ),
    value: LocationMotivation.Compensation,
  },
];

const getSelectedOptions = (selectedOptions) =>
  motivationOptions.filter((motivationOption) =>
    selectedOptions.includes(motivationOption.value)
  );

interface LocationMotivationProps {
  nextAction?: string;
  previousAction: string;
  stepNumber: number;
}

const OnboardingLocationMotivation = ({
  nextAction = null,
  previousAction,
  stepNumber,
}: LocationMotivationProps) => {
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  let { location_motivation: selectedLocationMotivations } = onboardingData;
  if (!selectedLocationMotivations) {
    selectedLocationMotivations = [];
  }

  return (
    <Center>
      <Onboarding
        currentStep={stepNumber}
        isNextDisabled={!selectedLocationMotivations.length}
        nextAction={nextAction}
        previousAction={previousAction}
        stepKeys={['location_motivation']}
        stepName="Location motivation"
      >
        <div>
          <OnboardingTitle>
            What matters to you when deciding where to work?
          </OnboardingTitle>
          <OnboardingSubtitle>
            We&apos;ll use this info to find the best opportunities for you!
          </OnboardingSubtitle>
        </div>
        <div>
          <LocationMotivationButtonSelect
            onChange={(_val, option, remove) =>
              remove
                ? setOnboardingData({
                    ...onboardingData,
                    location_motivation: selectedLocationMotivations.filter(
                      (selectedLocationMotivation) =>
                        selectedLocationMotivation !== option.value
                    ),
                  })
                : setOnboardingData({
                    ...onboardingData,
                    location_motivation: [
                      ...selectedLocationMotivations,
                      option.value,
                    ].sort(),
                  })
            }
            options={motivationOptions}
            selectedOptions={getSelectedOptions(selectedLocationMotivations)}
          />
        </div>
      </Onboarding>
    </Center>
  );
};

export default OnboardingLocationMotivation;
